<template lang="pug">
.loading(v-if='visible')
  .loading-area
    .icon
    .btn(@click="interrupt") STOP
</template>

<style lang="less">
@import '~@/assets/common.less';
.loading:extend(.center-mid, .full-screen) {
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10000;
  .loading-area:extend(.relative) {
    text-align: center;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px 30px 10px 30px;
    border-radius: 5px;
    > * { position: relative; }
    .icon {
      top: calc(50% - 100px);
      left: calc(50% - 25px);
      width: 50px;
      height: 50px;
      background-image: url('~@/assets/imgs/icon_loading.gif');
      background-size: auto 100%;}
    .btn {
      margin-top: 15px;
      color: rgb(86, 173, 236);
      font-weight: bold;
      font-family: Poppins;
    }
  }
}
</style>

<script>
export default {
  data: () => ({
    visible: false
  }),
  methods: {
    show () { this.visible = true },
    hide () { this.visible = false },
    interrupt () {
      this.visible = false
      this.$emit('interrupt')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/loading.vue